module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('autocomplete-category', {
    attrs: {
      "selected": _vm.activeCategory,
      "label": ((_vm.$t('item.category')) + " *"),
      "deletable": false
    },
    on: {
      "update:category": _vm.categoryIsUpdated
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bae7dca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/Form/CategoryField.vue
// module id = 1283
// module chunks = 1